'use es6';

import * as ProductLines from 'self-service-api/constants/ProductLines';
export default {
  [ProductLines.MARKETING]: 'marketing',
  [ProductLines.SALES]: 'sales',
  [ProductLines.SERVICE]: 'service',
  [ProductLines.CMS]: 'cms',
  [ProductLines.OPERATIONS]: 'operations'
};